// A family member's avatar text.

/** Up to two initials for a family member's avatar. */
export const initialsOf = (name: string) =>
  (name.trim().split(/\s+/).filter(Boolean).map(w => w[0]).join('').slice(0, 2) || '?').toUpperCase()

// Each family member wears a category tint, picked by their place in the
// household (members load in join order), so the same person has the same
// colour on every phone. Starts as the reference's family does: orange, blue,
// purple.
const MEMBER_TINTS = ['bakery', 'dairy', 'pantry', 'produce', 'frozen', 'household'] as const

export const memberTint = (index: number) => `var(--ml-cat-${MEMBER_TINTS[index % MEMBER_TINTS.length]})`
